export default __webpack_public_path__ + "static/media/toggle-notifications-b.d01444a1.svg";